import React from "react";
import PropTypes from "prop-types";

class IncrDecrSimple extends React.Component {
    render() {
        let { className, label, onDecr, onIncr } = this.props;
        return (
            <div
                className={`tde-s1 tde-toggle-btns-wrapper ${className || ''}`}
            >
                <div
                    className={`tde-input tde-incr_decr-input tde-flex-items-center`}
                    style={{ width: "auto" }}
                >
                    <button
                        aria-label={this.props.getLoc(
                            `Decrease ${label || ""}`
                        )}
                        className="tde-font-weight-bold tde-btn "
                        onClick={() => onDecr()}
                    >
                        <i className="tde-i tde-i-decrement"></i>
                    </button>
                    <button
                        aria-label={this.props.getLoc(
                            `Increase ${this.props.label || ""}`
                        )}
                        className="tde-font-weight-bold tde-btn"
                        onClick={() => onIncr()}
                    >
                        <i className="tde-i tde-i-increment"></i>
                    </button>
                </div>
            </div>
        );
    }
}

IncrDecrSimple.propTypes = {
    onIncr: PropTypes.func,
    onDecr: PropTypes.func,
    label: PropTypes.string,
    getLoc: PropTypes.func,
};

IncrDecrSimple.defaultProps = {};

export default IncrDecrSimple;
